module.exports = __webpack_public_path__ + "static/media/pin.6ec6dd4a.svg";